import request from './common/request'
import qs from 'qs'

import { MERCHANT_EVALUATION_RANK_TEMPLATE_URI } from './urls'

/**
 * 获取所有奖项模板列表
 * @param {*} data
 * @returns
 */
export const list = async data => {
  return request({
    url: MERCHANT_EVALUATION_RANK_TEMPLATE_URI,
    method: 'GET',
    params: data
  })
}

/**
 * 添加奖项模板
 * @param {*} data
 * @returns
 */
export const add = async data => {
  return request({
    url: MERCHANT_EVALUATION_RANK_TEMPLATE_URI,
    method: 'POST',
    data: qs.stringify(data)
  })
}

/**
 * 获取所有奖项模板列表
 * @param {*} data
 * @returns
 */
export const all = async data => {
  return request({
    url: `${MERCHANT_EVALUATION_RANK_TEMPLATE_URI}/all`,
    method: 'GET',
    params: data
  })
}

/**
 * 通过id查询模板详情
 * @param {*} id
 * @returns
 */
export const findById = async id => {
  return request({
    url: `${MERCHANT_EVALUATION_RANK_TEMPLATE_URI}/${id}`,
    method: 'GET'
  })
}

/**
 * 通过id更新模板信息
 * @param {*} data
 * @returns
 */
export const updateById = async (id, data) => {
  return request({
    url: `${MERCHANT_EVALUATION_RANK_TEMPLATE_URI}/${id}`,
    method: 'PUT',
    data: qs.stringify(data)
  })
}

/**
 * 通过id删除模板信息
 * @param {*} id
 * @returns
 */
export const deleteById = async id => {
  return request({
    url: `${MERCHANT_EVALUATION_RANK_TEMPLATE_URI}/${id}`,
    method: 'DELETE'
  })
}



// WEBPACK FOOTER //
// ./src/api/merchant-evaluation-rank-template.js